<template>
    <div class="view-container">
        <div class="max-grid">
            <ejs-grid ref="grid" height="100%" width="100%" :toolbar="toolbar" :toolbarClick="toolbarClick" :selectionSettings="selectionOptions" :allowTextWrap="true" :textWrapSettings="wrapSettings" :dataBound="dataBound" :dataSource="data" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true">
                <e-columns>
                    <e-column field="createDate" :headerText="$t('CreateDate')" textAlign="Left" :customAttributes="customAttributes" type="dateTime" :format="dateTimeFormatOptions"></e-column>
                    <e-column field="alarmName" :headerText="$t('AlarmName')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="description" :headerText="$t('Description')" width="500px" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="endDateString" :headerText="$t('EndDate')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                    <e-column field="dismissDateString" :headerText="$t('DismissDate')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                </e-columns>
            </ejs-grid>
        </div>
    </div>
</template>

<script>
import { CommandColumn, ExcelExport, Filter, Page, PdfExport, Search, Sort, Toolbar } from "@syncfusion/ej2-vue-grids";
import { getSystemGeneralAlarms } from "../../api/api";

export default {
    props: {
        systemName: {
            required: false,
            type: String
        },
        systemId: {
            required: false,
            type: String
        }
    },
    provide: {
        grid: [Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport],
    },
    components: {
    },
    data() {
        return {
            data: [],
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [
                { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right',},
                { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export'},
                { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export'},
                { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export'},
                'Search',
            ],
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "CheckBox",
            },
            customAttributes: { class: "customcss" },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' },
        }
    },
    methods: {
        async getData() {
            this.$store.dispatch('set_loading', true)
            getSystemGeneralAlarms(this.systemId).then((response) => {
                this.data = response.data
                this.data.forEach(el => {
                    var minDate = new Date("2001-01-01")
                    if(new Date(el.endDate) < minDate) {
                        el.endDateString = '-'
                    } else {
                        el.endDateString = el.endDate.toDateTime()
                    }

                    if(new Date(el.dismissDate) < minDate) {
                        el.dismissDateString = '-'
                    } else {
                        el.dismissDateString = el.dismissDate.toDateTime()
                    }
                })

                this.data.sort((b, a) => new Date(a.createDate) - new Date(b.createDate))
                this.$store.dispatch('set_loading', false)
            })
        },
        dataBound: function () {
            this.$refs.grid.autoFitColumns();
        },
        toolbarClick: function (args) {
            switch (args.item.id) {
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
    },
    mounted: function() {
        this.getData()
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/System/SystemGeneralAlarms.vue